module.exports = __webpack_public_path__ + "img/19.57b86055.jpg";